document.addEventListener('DOMContentLoaded', () => {
  const img = document.getElementById('proceso-img');
  const lens = document.getElementById('lens');
  const zoom = 2;

  lens.style.backgroundImage = `url('${img.src}')`;

  img.addEventListener('mousemove', moveLens);
  lens.addEventListener('mousemove', moveLens);
  img.addEventListener('mouseenter', () => (lens.style.display = 'block'));
  img.addEventListener('mouseleave', () => (lens.style.display = 'none'));

  function moveLens(e) {
    e.preventDefault();
    const rect = img.getBoundingClientRect();
    const lensRadius = lens.offsetWidth / 2;

    let x = e.clientX - rect.left;
    let y = e.clientY - rect.top;

    if (x < lensRadius / zoom) x = lensRadius / zoom;
    if (x > img.width - lensRadius / zoom) x = img.width - lensRadius / zoom;
    if (y < lensRadius / zoom) y = lensRadius / zoom;
    if (y > img.height - lensRadius / zoom) y = img.height - lensRadius / zoom;

    lens.style.left = `${x - lensRadius}px`;
    lens.style.top = `${y - lensRadius}px`;

    lens.style.backgroundPosition = `-${x * zoom - lensRadius}px -${y * zoom - lensRadius}px`;
    lens.style.backgroundSize = `${img.width * zoom}px ${img.height * zoom}px`;
  }
});
